import {Component, Inject, OnInit} from '@angular/core';
import {MessagesFilters} from "../../messages/messages-filter/messages-filter.interface";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-safety-observations-view-messages-filter',
  templateUrl: './safety-observations-view-messages-filter.component.html',
  styleUrls: ['./safety-observations-view-messages-filter.component.scss']
})
export class SafetyObservationsViewMessagesFilterComponent implements OnInit {

  filters: MessagesFilters = {
    type: '',
    status: '',
    priority: ''
  } as MessagesFilters;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SafetyObservationsViewMessagesFilterComponent>
  ) { }

  ngOnInit(): void {
    // Set default values if not provided.
    this.filters.type = this.data['type'] || '';
    this.filters.status = this.data['status'] || '';
    this.filters.priority = this.data['priority'] || '';
  }

  /**
   * Clears the filters and closes the form.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    // Clear the filters.
    this.filters.type = '';
    this.filters.status = '';
    this.filters.priority = '';

    this.onSaveAndClose();
  }

  /**
   * Saves the filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    this.dialogRef.close(this.filters);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
